import React from "react";

/**
 * Chat input component with text input and send button
 * @param {Object} props
 * @param {string} props.messageInput - Current message input value
 * @param {Function} props.onMessageChange - Handler for input change (receives value directly)
 * @param {Function} props.onSend - Handler for sending message
 * @param {Function} props.onKeyPress - Handler for key press events
 * @param {boolean} props.isSending - Whether a message is being sent (for current session only)
 * @param {string|null} props.currentSessionId - Current session ID
 */
const ChatInput = ({
  messageInput,
  onMessageChange,
  onSend,
  onKeyPress,
  isSending,
  currentSessionId,
}) => {
  return (
    <div className="input-container">
      <input
        type="text"
        placeholder={
          currentSessionId
            ? "Type your message here..."
            : "Generate an EWA session first to start chatting..."
        }
        className="message-input"
        value={messageInput}
        onChange={(e) => onMessageChange(e.target.value)}
        onKeyPress={onKeyPress}
        disabled={isSending || !currentSessionId}
      />
      <button
        className="send-button"
        onClick={onSend}
        disabled={isSending || !messageInput.trim() || !currentSessionId}
      >
        {isSending ? "Sending..." : "Send"}
      </button>
    </div>
  );
};

export default ChatInput;
